const angular = require('angular');

const { RatingService } = require('./rating.service');
const { starComponentDefinition } = require('./star.component');
const { ratingComponentDefinition } = require('./rating.component');
const { ratingDetailComponentDefinition } = require('./rating-detail.component');
const { ratingBarComponentDefinition } = require('./rating-bar.component');

angular.module('wowApp.shop')
    .service('RatingService', RatingService)
    .component('wowStar', starComponentDefinition)
    .component('wowRating', ratingComponentDefinition)
    .component('wowRatingDetail', ratingDetailComponentDefinition)
    .component('wowRatingBar', ratingBarComponentDefinition);



// WEBPACK FOOTER //
// ./src/shop/rating/index.js